import { of } from 'rxjs';
import { mapTo } from 'rxjs/operators';
import { OrderedSet } from 'immutable';
import { flog } from '@zambezi/caballo-vivo';
export var createLoading$ = function createLoading$(message) {
  return of(message).pipe(flog("Loading message \"".concat(message, "\"")), mapTo(function (state) {
    return state.update('loading', createStackLoading(message));
  }));
};
export var clearLoading$ = of(function (state) {
  return state.set('loading', OrderedSet());
}).pipe(flog('Clear loading message'));
function createStackLoading(msg) {
  return function updateLoading(loading) {
    if (!loading) return OrderedSet([msg]);
    return loading.add(msg);
  };
}
export function createClearLoading$(message) {
  return of(message).pipe(flog("Clearing load message \"".concat(message, "\"")), mapTo(function (state) {
    return state.update('loading', function (loading) {
      if (!loading) return OrderedSet();
      return loading.delete(message);
    });
  }));
}